import { Home, Layers, ShoppingBag, Heart, User } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "@/hooks/useCart";
import { useWishlist } from "@/hooks/useWishlist";
import { useAuth } from "@/hooks/useAuth";

export function MobileBottomNav() {
  const { pathname } = useLocation();
  const { items } = useCart();
  const { items: wishlistItems } = useWishlist();
  const { user } = useAuth();
  
  const cartCount = items.reduce((acc, item) => acc + item.quantity, 0);
  const wishlistCount = wishlistItems.length;

  const isActive = (path: string) => {
    if (path === "/" && pathname === "/") return true;
    if (path !== "/" && pathname.startsWith(path)) return true;
    return false;
  };

  const navItems = [
    { label: "Home", icon: Home, path: "/" },
    { label: "Shop", icon: Layers, path: "/shop" },
    { label: "Wishlist", icon: Heart, path: "/profile", count: wishlistCount },
    { label: "Cart", icon: ShoppingBag, path: "/cart", count: cartCount },
    { label: "Account", icon: User, path: "/profile" },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border lg:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <Link
            key={item.label}
            to={item.path}
            className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${
              isActive(item.path) 
                ? "text-primary" 
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <div className="relative">
              <item.icon size={20} className={isActive(item.path) ? "fill-current" : ""} />
              {item.count !== undefined && item.count > 0 && (
                <span className="absolute -top-1.5 -right-1.5 flex items-center justify-center w-4 h-4 text-[10px] font-bold text-white bg-primary rounded-full">
                  {item.count > 9 ? "9+" : item.count}
                </span>
              )}
            </div>
            <span className="text-[10px] font-medium tracking-wide uppercase">{item.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
